import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/mixpanel"

// Timesheets → Export for a week (Kloepfer K13-18, Larry Oct 27): before the
// Excel, CSV or Interac file downloads, ask what's still pending that week.
// Nothing → it downloads like before. Anything → a pop-up lists it with
// people's names, with Cancel and Export anyway. A warning, never a block:
// if the check itself fails, the file downloads.
export default class extends Controller {
  static targets = ["modal", "list"]
  static values = { url: String }

  async check(event) {
    const link = event.currentTarget
    if (event.metaKey || event.ctrlKey || event.shiftKey) return
    event.preventDefault()
    this.href = link.href
    this.file = link.dataset.file || ""

    let groups = []
    try {
      const res = await fetch(this.urlValue, { credentials: "same-origin", headers: { Accept: "application/json" } })
      if (res.ok) groups = (await res.json()).groups || []
    } catch (_) {
      groups = []
    }
    if (groups.length === 0) return this._download()

    this._render(groups)
    this.modalTarget.classList.remove("hidden")
    track("Timesheet Export Warning Shown", { file_type: this.file, kinds: groups.map((g) => g.key), people_count: groups.reduce((n, g) => n + g.count, 0) })
  }

  exportAnyway() {
    track("Timesheet Export Warning Overridden", { file_type: this.file })
    this.hideModal()
    this._download()
  }

  hideModal() {
    this.modalTarget.classList.add("hidden")
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  _download() {
    if (this.href) window.location.href = this.href
  }

  _render(groups) {
    this.listTarget.replaceChildren(...groups.map((g) => {
      const item = document.createElement("li")
      item.className = "rounded-md border border-amber-200 bg-amber-50 px-3 py-2"
      const label = document.createElement("div")
      label.className = "font-medium text-amber-900"
      label.textContent = `${g.label} · ${g.count}`
      const names = document.createElement("div")
      names.className = "mt-0.5 text-gray-700"
      names.textContent = g.names.join(", ")
      item.append(label, names)
      return item
    }))
  }
}
